import { generateOptionValueFromEntity } from 'components/PlatformResourceSelector/utils';
import { useRouter } from 'next/router';
import { usePanelContext } from 'modules/Playground/Components/PanelContext';

const getPanelQueryParams = (panelId: string, currentModel: CF.API.Models.Model) => {
  const modelId = generateOptionValueFromEntity(currentModel as unknown as CF.API.Models.Model);
  if (!modelId) return {};
  return panelId === 'left'
    ? { model: modelId, user_id: currentModel.user_id, app_id: currentModel.app_id }
    : { model2: modelId, model2_user_id: currentModel.user_id, model2_app_id: currentModel.app_id };
};

export const usePlaygroundModelSelectorChange = () => {
  const router = useRouter();
  const panelId = usePanelContext() as string;

  const handleModelChange = (currentModel: CF.API.Models.Model) => {
    router.push({ query: { ...router.query, ...getPanelQueryParams(panelId, currentModel) } }, undefined, {
      shallow: true,
    });
  };

  return { handleModelChange };
};
